var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { CpaPrice, ProductSpecialRestrictionCode } from '@millerknoll/pub-api-schema';
import { useCpaProduct } from 'components/Cpa/CpaProduct/CpaProductContextProvider';
import { Loading } from 'components/Shared/Loading/AppLoading/Loading/Loading';
import { PubTable } from 'components/Shared/PubTable/PubTable';
import { WorkflowModal } from 'components/Shared/WorkflowModal/WorkFlowModal';
import { InputFieldType } from 'models/Input/InputModels';
import { useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { useAuth } from 'services/auth/AuthProvider';
import { useBanner, BannerMessageType, BannerIconType } from 'components/Shared/BannerContext/BannerContext';
import { createLock, PRICING_CHANGES_REMOVE_HOLD_RESTRICTION_COMMENT, checkUserLockPreventsEdit, } from 'utils/cpa-utils';
import { textFormatHelper } from 'utils/text-format-helper';
import { useGetPriceListDates } from 'hooks/useGetPriceListDates';
import { DeleteRowWorkflowModal } from '../DeleteRowWorkflowModal/DeleteRowWorkflowModal';
export function PricingTable(_a) {
    var _this = this;
    var _b, _c, _d, _e;
    var _f = _a.showAddRow, showAddRow = _f === void 0 ? false : _f, showAddRowAction = _a.showAddRowAction;
    var user = useAuth();
    var cpaProductContext = useCpaProduct();
    var OVERRIDE_NO_ZERO_NEGATIVE = 'Zero and negative values are not allowed';
    var _g = useState({}), tableData = _g[0], setTableData = _g[1];
    var _h = useState(), tableDataOriginal = _h[0], setTableDataOriginal = _h[1];
    var _j = useState(false), isModalOpen = _j[0], setIsModalOpen = _j[1];
    var _k = useState(false), isDeleteModalOpen = _k[0], setIsDeleteModalOpen = _k[1];
    var _l = useState(0), resetFormKey = _l[0], setResetFormKey = _l[1];
    var _m = useState(false), shouldResetForm = _m[0], setShouldResetForm = _m[1];
    var selectedRow = useRef();
    var _o = useBanner(), setBannerMessage = _o.setBannerMessage, setBannerType = _o.setBannerType, setBannerIcon = _o.setBannerIcon, setShowBanner = _o.setShowBanner, setIsRefreshEnabled = _o.setIsRefreshEnabled;
    var _p = useGetPriceListDates(), datesLoading = _p.loading, dateList = _p.dateList;
    useLayoutEffect(function () {
        if (cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.pricingTableData) {
            setTableData(cpaProductContext.data.pricingTableData);
            if (!tableDataOriginal)
                setTableDataOriginal(cpaProductContext.data.pricingTableData);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.pricingTableData]);
    useEffect(function () {
        if (shouldResetForm) {
            setResetFormKey(function (prev) { return prev + 1; });
            setShouldResetForm(false);
        }
    }, [shouldResetForm]);
    var tableDataDefinition = useMemo(function () {
        var _a;
        var startDates = __spreadArray([], (dateList !== null && dateList !== void 0 ? dateList : []), true).filter(function (date) { return !Object.keys(tableData).includes(textFormatHelper.removeHyphens(date)); });
        var priceType = +"".concat((_a = cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.standardProductPrice) === null || _a === void 0 ? void 0 : _a.returnCode) !== 0
            ? textFormatHelper.snakeCaseToNormalText(CpaPrice.priceType.OVERRIDE, true)
            : textFormatHelper.snakeCaseToNormalText(CpaPrice.priceType.ADJUSTMENT, true);
        var defaultRow = {
            row: {
                startDate: Object.keys(tableData).length === 0
                    ? startDates[0]
                    : __spreadArray([], startDates, true).reverse()
                        .find(function (date) { return new Date(date).getTime() <= new Date().getTime(); }),
                priceType: priceType,
                priceAdjustment: 0,
                reviewIndicator: 'No',
                lastReviewDate: __spreadArray([], (dateList !== null && dateList !== void 0 ? dateList : []), true).reverse()
                    .find(function (date) { return new Date(date).getTime() <= new Date().getTime(); }),
            },
            key: "default-".concat(resetFormKey),
        };
        return {
            firstColumnIndent: true,
            noDataMessage: 'No Pricing Data',
            addRowWhenNoData: true,
            defaultRow: defaultRow,
            sortProps: { sortByKey: true, keyType: 'DATE', sortOrder: 'desc' },
            columns: [
                {
                    dataAttribute: 'startDate',
                    fieldType: InputFieldType.ENUM,
                    heading: 'Start Date',
                    allowedFieldValues: startDates,
                    defaultValue: defaultRow.row.startDate,
                    required: true,
                    isUnique: true,
                    width: '200px',
                },
                {
                    dataAttribute: 'priceType',
                    fieldType: InputFieldType.ENUM,
                    allowedFieldValues: Object.values(CpaPrice.priceType).map(function (type) {
                        return textFormatHelper.snakeCaseToNormalText(type, true);
                    }),
                    heading: 'Price Type',
                    defaultValue: defaultRow.row.priceType,
                    required: true,
                    width: '200px',
                },
                {
                    dataAttribute: 'priceAdjustment',
                    fieldType: InputFieldType.NUMBER,
                    heading: 'Price Value',
                    defaultValue: defaultRow.row.priceAdjustment,
                    required: true,
                    validations: {
                        required: 'Price Value required',
                        wholeNumbersOnly: 'Decimals are not allowed',
                    },
                    width: '200px',
                },
                {
                    dataAttribute: 'reviewIndicator',
                    fieldType: InputFieldType.ENUM,
                    allowedFieldValues: ['Yes', 'No'],
                    heading: 'Needs Review?',
                    defaultValue: defaultRow.row.reviewIndicator,
                    required: true,
                    width: '200px',
                },
                {
                    dataAttribute: 'lastReviewDate',
                    fieldType: InputFieldType.ENUM,
                    heading: 'Last Reviewed',
                    allowedFieldValues: dateList !== null && dateList !== void 0 ? dateList : [],
                    defaultValue: defaultRow.row.lastReviewDate,
                    required: true,
                    width: '200px',
                },
            ],
            showAddRow: showAddRow,
            showAddRowHandler: function () {
                var hasExistingRows = Object.keys(tableData).length > 0;
                if (hasExistingRows) {
                    showAddRowAction();
                }
                else {
                    setShouldResetForm(true);
                }
            },
            disableEdit: function (_key) { return checkUserLockPreventsEdit(cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.cpn); },
            editHandler: function (key, row) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            selectedRow.current = { row: row, key: key };
                            return [4 /*yield*/, handleCreateLock()];
                        case 1:
                            _a.sent();
                            setIsModalOpen(true);
                            return [2 /*return*/];
                    }
                });
            }); },
            validateRow: function (row) {
                var errors = {};
                if (row.priceType.toUpperCase() === CpaPrice.priceType.OVERRIDE && row.priceAdjustment <= 0) {
                    errors.priceAdjustment = OVERRIDE_NO_ZERO_NEGATIVE;
                }
                return errors;
            },
            addHandler: function (row) {
                selectedRow.current = { row: row, key: '' };
                setIsModalOpen(true);
            },
            deleteProps: {
                deleteHandler: function (key, row) { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!(cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data) || !cpaProductContext.data.cpn)
                                    return [2 /*return*/];
                                return [4 /*yield*/, handleCreateLock()];
                            case 1:
                                _a.sent();
                                setIsDeleteModalOpen(true);
                                selectedRow.current = { row: row, key: key };
                                return [2 /*return*/];
                        }
                    });
                }); },
                disabled: cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.isEditDisabled,
            },
        };
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data, showAddRow, tableData, dateList, resetFormKey]);
    function handleCreateLock() {
        return __awaiter(this, void 0, void 0, function () {
            var cpn, sessionId, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cpn = cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.cpn;
                        sessionId = sessionStorage.getItem("".concat(cpn, "_identifier"));
                        if (!(cpn && sessionId && user && user.user)) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, createLock(cpn, user.user.name, sessionId, cpaProductContext.data.currentProduct.startDate)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        setBannerMessage("This record is locked because it's currently being edited by somone else. Please reload by clicking here: ");
                        setBannerType(BannerMessageType.Warning);
                        setBannerIcon(BannerIconType.Error);
                        setShowBanner(true);
                        setIsRefreshEnabled(true);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    function setCpaPriceEdit(row, key) {
        var _a, _b, _c;
        var startDate = textFormatHelper.removeHyphens(row.startDate);
        var price = {
            insertId: (_a = row.insertId) !== null && _a !== void 0 ? _a : (_b = user.user) === null || _b === void 0 ? void 0 : _b.userId,
            insertTimestamp: row.insertTimestamp,
            updateId: (_c = user.user) === null || _c === void 0 ? void 0 : _c.userId,
            updateTimestamp: row.updateTimestamp,
            priceAdjustment: +row.priceAdjustment,
            reviewIndicator: row.reviewIndicator,
            priceType: row.priceType,
            startDate: row.startDate,
            lastReviewDate: row.lastReviewDate,
            workflow: row.workflow,
        };
        if (startDate !== key) {
            delete tableData[key];
        }
        setTableData(function (prev) {
            prev[startDate] = price;
            cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.dispatch({ type: 'UPDATE_PRICING_TABLE_DATA', payload: __assign({}, prev) });
            return prev;
        });
    }
    function setCpaPriceAdd(row) {
        var _a, _b;
        var startDate = textFormatHelper.removeHyphens(row.startDate);
        var timestamp = new Date().toISOString();
        var price = {
            insertId: (_a = user.user) === null || _a === void 0 ? void 0 : _a.userId,
            insertTimestamp: timestamp,
            updateId: (_b = user.user) === null || _b === void 0 ? void 0 : _b.userId,
            updateTimestamp: timestamp,
            priceAdjustment: +row.priceAdjustment,
            reviewIndicator: row.reviewIndicator,
            priceType: row.priceType,
            startDate: row.startDate,
            lastReviewDate: row.lastReviewDate,
            workflow: row.workflow,
        };
        setTableData(function (prev) {
            var _a;
            prev[startDate] = price;
            cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.dispatch({
                type: 'UPDATE_PRICING_TABLE_DATA',
                payload: __assign(__assign({}, prev), (_a = {}, _a[startDate] = price, _a)),
            });
            return prev;
        });
    }
    function setCpaPrice(row, key) {
        if (key === '') {
            setCpaPriceAdd(row);
        }
        if (key) {
            setCpaPriceEdit(row, key);
        }
    }
    return (cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.standardProductPrice) &&
        cpaProductContext.data.standardProductPrice.returnCode !== undefined &&
        !datesLoading ? (_jsxs(_Fragment, { children: [_jsx(PubTable, { def: tableDataDefinition, tableData: tableData, alternateRowBackgroundColor: true }), isModalOpen && (_jsx(WorkflowModal, { isOpen: isModalOpen, setIsOpen: setIsModalOpen, title: ((_e = (_d = (_c = (_b = cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data) === null || _b === void 0 ? void 0 : _b.currentProduct) === null || _c === void 0 ? void 0 : _c.restrictions) === null || _d === void 0 ? void 0 : _d[ProductSpecialRestrictionCode === null || ProductSpecialRestrictionCode === void 0 ? void 0 : ProductSpecialRestrictionCode.PRERELEASE]) === null || _e === void 0 ? void 0 : _e.isActive) === true, buttonProps: [
                    {
                        labelText: 'Confirm',
                        backgroundColorVariation: 'primary',
                        width: '120px',
                        buttonAction: function (workflow) { return __awaiter(_this, void 0, void 0, function () {
                            var row;
                            var _a, _b, _c, _d;
                            return __generator(this, function (_e) {
                                switch (_e.label) {
                                    case 0:
                                        row = __assign(__assign({}, (_a = selectedRow.current) === null || _a === void 0 ? void 0 : _a.row), { workflow: workflow });
                                        if (!cpaProductContext || !cpaProductContext.data.currentProduct || !row) {
                                            return [2 /*return*/];
                                        }
                                        if (!((_c = (_b = cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data) === null || _b === void 0 ? void 0 : _b.currentProduct) === null || _c === void 0 ? void 0 : _c.restrictions)) {
                                            cpaProductContext.data.currentProduct.restrictions = {};
                                        }
                                        cpaProductContext.data.currentProduct.restrictions[ProductSpecialRestrictionCode.PRERELEASE] = { isActive: false, comment: PRICING_CHANGES_REMOVE_HOLD_RESTRICTION_COMMENT };
                                        setCpaPrice(row, (_d = selectedRow.current) === null || _d === void 0 ? void 0 : _d.key);
                                        selectedRow.current = undefined;
                                        setIsModalOpen(false);
                                        return [4 /*yield*/, handleCreateLock()];
                                    case 1:
                                        _e.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); },
                    },
                    {
                        labelText: 'Cancel',
                        backgroundColorVariation: 'secondary',
                        width: '120px',
                        buttonAction: function (workflow) {
                            var _a, _b, _c, _d, _e, _f, _g;
                            if (((_d = (_c = (_b = (_a = cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data) === null || _a === void 0 ? void 0 : _a.currentProduct) === null || _b === void 0 ? void 0 : _b.restrictions) === null || _c === void 0 ? void 0 : _c[ProductSpecialRestrictionCode.PRERELEASE]) === null || _d === void 0 ? void 0 : _d.isActive) === true &&
                                ((_e = selectedRow.current) === null || _e === void 0 ? void 0 : _e.key) !== '') {
                                var row = __assign(__assign({}, (_f = selectedRow.current) === null || _f === void 0 ? void 0 : _f.row), { workflow: workflow });
                                if (!cpaProductContext || !cpaProductContext.data.currentProduct || !row) {
                                    return;
                                }
                                setCpaPrice(row, (_g = selectedRow.current) === null || _g === void 0 ? void 0 : _g.key);
                            }
                            selectedRow.current = undefined;
                            setIsModalOpen(false);
                            if (Object.keys(tableData).length === 0) {
                                setShouldResetForm(true);
                            }
                        },
                    },
                ], messages: ['Product is on Prerelease Hold. Confirm to remove the Prerelease Hold?'] })), isDeleteModalOpen && (_jsx(DeleteRowWorkflowModal, { deleteAction: function (actionType, workflow, releaseHold) {
                    var _a;
                    var _b, _c, _d, _e, _f, _g, _h, _j;
                    // conditions for which the delete was canceled or unable to be deleted
                    if (!cpaProductContext ||
                        !cpaProductContext.data.currentProduct ||
                        !cpaProductContext.data.pricingTableDataOriginal ||
                        actionType === 'cancel' ||
                        ((_b = selectedRow.current) === null || _b === void 0 ? void 0 : _b.key) === undefined) {
                        setIsDeleteModalOpen(false);
                        return;
                    }
                    // check if the row was in the table data on page load or after last product save
                    // if so, add workflow to that price row
                    var isInOriginalData = !!((_c = cpaProductContext.data.pricingTableDataOriginal) === null || _c === void 0 ? void 0 : _c[(_d = selectedRow.current) === null || _d === void 0 ? void 0 : _d.key]);
                    if (isInOriginalData) {
                        cpaProductContext.dispatch({
                            type: 'UPDATE_PRICING_TABLE_DATA_ORIGINAL',
                            payload: __assign(__assign({}, cpaProductContext.data.pricingTableDataOriginal), (_a = {}, _a[(_e = selectedRow.current) === null || _e === void 0 ? void 0 : _e.key] = __assign(__assign({}, (_f = cpaProductContext.data.pricingTableDataOriginal) === null || _f === void 0 ? void 0 : _f[(_g = selectedRow.current) === null || _g === void 0 ? void 0 : _g.key]), { workflow: workflow }), _a)),
                        });
                    }
                    // remove deleted row from current pricing table data
                    var tableCopy = __assign({}, tableData);
                    var deletedKey = selectedRow.current.key;
                    delete tableCopy[deletedKey];
                    setTableData(function (prev) {
                        delete prev[deletedKey];
                        cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.dispatch({
                            type: 'UPDATE_PRICING_TABLE_DATA',
                            payload: __assign({}, prev),
                        });
                        return prev;
                    });
                    // release prerelease hold
                    if (releaseHold) {
                        if (!((_j = (_h = cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data) === null || _h === void 0 ? void 0 : _h.currentProduct) === null || _j === void 0 ? void 0 : _j.restrictions)) {
                            cpaProductContext.data.currentProduct.restrictions = {};
                        }
                        cpaProductContext.data.currentProduct.restrictions[ProductSpecialRestrictionCode.PRERELEASE] = { isActive: false, comment: PRICING_CHANGES_REMOVE_HOLD_RESTRICTION_COMMENT };
                    }
                    selectedRow.current = undefined;
                    setIsDeleteModalOpen(false);
                }, deleteProps: {
                    modalProps: {
                        buttonProps: { confirmText: 'Delete Price', cancelText: 'Keep Price' },
                        bodyTextArray: [
                            'Are you sure you would like to delete this price? This action is permanent.',
                        ],
                        titleText: 'Delete Price',
                    },
                } }))] })) : (_jsx(Loading, {}));
}
